import styled from 'styled-components'

export const SelectedSkus = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const SkuContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  flex-wrap: wrap;
`
